import { render, staticRenderFns } from "./cooperationPartner.vue?vue&type=template&id=333d2b79&scoped=true"
import script from "./cooperationPartner.vue?vue&type=script&lang=js"
export * from "./cooperationPartner.vue?vue&type=script&lang=js"
import style0 from "./cooperationPartner.vue?vue&type=style&index=0&id=333d2b79&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333d2b79",
  null
  
)

export default component.exports